import React from "react";
import ReactDOM from "react-dom";
import SimulateurCreditImmo from "./SimulateurCreditImmo";
import SimulateurCreditConso from "./SimulateurCreditConso";
import SimulateurDepotATerme from "./SimulateurDepotATerme";
import SimulateurEpargne from "./SimulateurEpargne";
import "react-tooltip/dist/react-tooltip.css";
import "./simulateur.css"; // Ensure the CSS file is correctly imported
import SimulateurPRP from "./SimulateurPRP";

ReactDOM.render(
  <React.StrictMode>
    <div className="container-fluid">
      <div class="row simulateurs-wrapper">
        <div class="col-md-3 gray-bg">
          <div
            class="nav flex-column nav-tabs simulateurs-tabs"
            id="tabMenu"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link active"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              Simulateur de Crédit Immobilier
            </a>
            <a
              class="nav-link"
              id="credit-tab"
              data-toggle="tab"
              href="#credit"
              role="tab"
              aria-controls="credit"
              aria-selected="false"
            >
              Simulateur de Crédit à la Consommation
            </a>
            <a
              class="nav-link"
              id="depot-tab"
              data-toggle="tab"
              href="#depot"
              role="tab"
              aria-controls="depot"
              aria-selected="false"
            >
              Simulateur de dépôt à Terme
            </a>
            <a
              class="nav-link"
              id="epargne-tab"
              data-toggle="tab"
              href="#epargne"
              role="tab"
              aria-controls="epargne"
              aria-selected="false"
            >
              Simulateur d'Epargne
            </a>

            <a
              class="nav-link"
              id="prp-tab"
              data-toggle="tab"
              href="#prp"
              role="tab"
              aria-controls="prp"
              aria-selected="false"
            >
              Simulateur de Prêt Personnel
            </a>
          </div>
        </div>
        <div class="col-md-9">
          <div class="tab-content" id="tabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <SimulateurCreditImmo titre="Simulateur de Crédit Immobilier" />
            </div>
            <div
              class="tab-pane fade"
              id="credit"
              role="tabpanel"
              aria-labelledby="credit-tab"
            >
              <SimulateurCreditConso titre="Simulateur de Crédit à la Consommation" />
            </div>
            <div
              class="tab-pane fade"
              id="depot"
              role="tabpanel"
              aria-labelledby="depot-tab"
            >
              <SimulateurDepotATerme titre="Simulateur de dépôt à Terme" />
            </div>
            <div
              class="tab-pane fade"
              id="epargne"
              role="tabpanel"
              aria-labelledby="epargne-tab"
            >
              <SimulateurEpargne titre="Simulateur d'Epargne" />
            </div>

            <div
              class="tab-pane fade"
              id="prp"
              role="tabpanel"
              aria-labelledby="prp-tab"
            >
              <SimulateurPRP titre="Simulateur de Prêt Personnel" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.StrictMode>,
  document.getElementById("react-app")
);
